import React, { useContext, useEffect, useState } from 'react'
import { Col } from 'react-bootstrap'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { themeDefault } from '../../themes/containerTheme'
import { DesignContext } from 'contexts/DesignContext'
import FormLoading from 'components/Loader/FormLoading'
import {
  checkHasShow,
  checkIsShow,
} from 'designer/component/action/condition/Action'
import { getShowUiConfig } from 'designer/component/action/Config'
import useAuth from 'hooks/useAuth'

const ComponentWrapper = (props) => {
  let {
    uischema,
    children,
    theme = themeDefault,
    isLoad = false,
    height,
    id,
  } = props

  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext
  const { config } = useAuth()
  const isShowUiConfig = getShowUiConfig({ uischema, config, jsonForm })
  let hasShow = checkHasShow({ designContext, uischema, config: props.config })
  let isShow = checkIsShow({ designContext, uischema, config: props.config })
  let isDisplayShow = hasShow ? isShow : isShowUiConfig
  let shouldRenderChildren = isDisplayShow

  const [doneLoad, setDoneLoad] = useState(false)
  useEffect(() => {
    if (!isLoad) {
      setTimeout(() => {
        setDoneLoad(true)
      }, 0)
    }
  }, [isLoad])

  return (
    <Col
      key={id}
      sm={uischema.layoutWidth}
      style={{
        padding: uischema.layoutPadding ?? '',
        margin: uischema.layoutMargin ?? '',
        display: uischema.tagname === 'tab' ? 'contents' : '',
      }}
      hidden={!isDisplayShow}
    >
      {isLoad ? (
        <FormLoading height={height} />
      ) : (
        <div
          style={{
            opacity: !doneLoad ? '0' : '100%',
            transition: 'all .3s ease-in-out',
          }}
        >
          {shouldRenderChildren && (
            <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
          )}
        </div>
      )}
    </Col>
  )
}

export default ComponentWrapper
